import { render, staticRenderFns } from "./navigationDialog.vue?vue&type=template&id=61ccb880&scoped=true&"
import script from "./navigationDialog.vue?vue&type=script&lang=js&"
export * from "./navigationDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ccb880",
  null
  
)

export default component.exports